<template>
    <transition name="fade">
        <div v-if="show" class="modal-backdrop" @click="handleCancel">
            <div class="price-locked-modal" @click.stop>
                <div class="modal-header">
                    <i class="pi pi-lock"></i>
                    <h2>Benefit is on Multiple Plans</h2>
                </div>
                <div class="modal-body">
                    <p>The benefit {{ benefitName }} is included with other plans.</p>
                    <p><strong>Changing this benefit's value will update it on your other plans and may impact the price of those plans.</strong></p>
                    <p>Would you like to change its value anyways?</p>
                </div>
                <div class="modal-footer">
                    <button class="btn-cancel" @click="handleCancel">Cancel</button>
                    <button class="btn-confirm" @click="handleConfirm">Yes, Change Value</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'ChangePriceAlertModal',
    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        benefit: {
            type: Object,
        }
    },
    computed: {
        benefitName() {
            return this.benefit?.name || '';
        }
    },
    methods: {
        ...mapActions(['setAllowMultiPlanPriceChanges']),
        handleCancel() {
            this.$emit('cancel');
        },
        async handleConfirm() {
            // Set session-wide flag to allow price changes for all multi-plan benefits
            await this.setAllowMultiPlanPriceChanges(true);
            
            // Emit events for parent to handle
            this.$emit('confirm');
            this.$emit('benefitUpdated');
        }
    }
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.price-locked-modal {
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    max-width: 500px;
    width: 90%;
    overflow: hidden;
}

.modal-header {
    background-color: var(--color-bright-blue);
    color: white;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.modal-header .pi-lock {
    font-size: 2em;
}

.modal-header h2 {
    margin: 0;
    font-size: 1.5em;
    font-weight: 600;
}

.modal-body {
    padding: 32px 24px;
    color: #333;
}

.modal-body p {
    margin: 0 0 16px 0;
    line-height: 1.6;
    font-size: 1.05em;
}

.modal-body p:last-child {
    margin-bottom: 0;
    font-size: 1.1em;
    color: #555;
}

.modal-body strong {
    color: var(--color-bright-blue);
}

.modal-footer {
    padding: 20px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background-color: #f5f5f5;
    border-top: 1px solid #e0e0e0;
}

.btn-cancel,
.btn-confirm {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-size: 1em;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-cancel {
    background-color: #fff;
    color: #666;
    border: 2px solid #ddd;
}

.btn-cancel:hover {
    background-color: #f5f5f5;
    border-color: #bbb;
}

.btn-confirm {
    background-color: var(--color-bright-blue);
    color: white;
    border: 2px solid var(--color-bright-blue);
}

.btn-confirm:hover {
    background-color: var(--color-dark-blue);
    border-color: var(--color-dark-blue);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

